import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import getUrlByUid from 'src/common/utils/get-url-by-uid.js';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

import './Breadcrumbs.scss';


const Breadcrumbs = ({ items }) => {
  const params = useParams();

  return (
    <div className="breadcrumbs">
      {items.map(({ label, link }, i) => {
        const formattedLabel = replaceTextWithValues(label, params);

        return (
          <div className="breadcrumbs__breadcrumb" key={`breadcrumb_${i}`}>
            {link.uid && <a href={getUrlByUid(link.uid)}>{formattedLabel}</a>}{' '}
            {!link.uid && <span>{formattedLabel}</span>}
            {i < items.length - 1 && (
              <span className="breadcrumbs__breadcrumb__separator">&gt;</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.object
    })
  )
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Breadcrumbs/Breadcrumbs.js